import React from 'react'
import { TextInput } from "react-native"
import { Container } from "."
import { useTheme } from 'react-native-paper'
import { helpers } from '@linqpal/common-frontend'
import { SearchGrey } from '../../assets/icons'

const { composeStyle, webSpecificStyle } = helpers

export const SearchBarWithPlaceholder = ({value, onChangeText, placeholder, style, ...props}) => {
    const {
        colors: { borderLight, accentText, primary },
        fonts: {
          medium
        }
      } = useTheme()

    return(
        <Container minified style={{
            flex: 1,
            height: 50,
            borderRadius: 8,
            borderWidth: 1,
            borderColor: '#E6EBEE',
            flexDirection: 'row',
            alignItems: 'center',
            ...style
        }} {...props}>
            <SearchGrey style={{width: 14, height: 14, marginRight: 8, marginLeft: 16}}/>
            <TextInput name={'search'} onChangeText={onChangeText} value={value} placeholder={placeholder} placeholderTextColor={'#99ADBA'}
                style={composeStyle(
                    {
                        flex: 1,
                        color: primary,
                        ...medium
                    },
                    webSpecificStyle({
                        outline: 'none',
                        caretColor: accentText,
                    })
                )}
            />
        </Container> 
    )
}